import { getActiveRegionId } from '@sportworld/js-sdk/src/actions/region'

import { ApiService } from '@/service'

export const getImprintData = async () => {
  const regionId = getActiveRegionId()
  const res = await ApiService.getImprintData(regionId)
  return res.data.html
}

export const getPrivacyData = async () => {
  const regionId = getActiveRegionId()
  const res = await ApiService.getPrivacyData(regionId)
  return res.data.html
}

export const getTermsConditions = async () => {
  const regionId = getActiveRegionId()
  const res = await ApiService.getTermsConditions(regionId)
  return res.data.html
}
